import React, { FC } from 'react';

import App from '../../../models/app';
import { payloadFromApp } from '../../../utils';
import { getContactUrl } from './util';
import fsc from 'fsc';
import { ContactRow } from './ContactRow';
import { DeveloperContactProps } from './types';

interface DeveloperContactButtonProps {
  id: string;
  app: App;
  phoneAppVersion?: string;
  label: string;
  showLabel?: boolean;
  deviceName: string;
  LinkComponent?: React.ComponentType<DeveloperContactProps>;
}

export const DeveloperContactButton: FC<DeveloperContactButtonProps> = ({
  app,
  phoneAppVersion,
  label,
  showLabel,
  LinkComponent = ContactRow,
  deviceName,
  id,
}) => {
  const { contactUrl, contactEmail, developer } = app;

  const handleContactBtnClicked = () => {
    fsc
      .view(`${app.isClock ? 'Clock' : 'App'} Details`)
      .Tapped('Contact Developer')
      .withPayload(payloadFromApp(app))
      .send();
  };

  if (contactUrl || contactEmail) {
    const contactUrl = getContactUrl(app, phoneAppVersion, deviceName);
    return (
      <LinkComponent
        id={id}
        label={label}
        developerName={developer.name}
        href={contactUrl}
        target="_blank"
        onClick={handleContactBtnClicked}
      />
    );
  } else if (showLabel) {
    return <span>{label}</span>;
  }
  return <React.Fragment />;
};